// set by api-gateway to track requests across all services
const X_REQUEST_ID = 'x-request-id';

const getRequestIdFromHeaders = (headers?: Record<any, any>): string | undefined => {
  if (headers && headers[X_REQUEST_ID]) {
    const requestId = headers[X_REQUEST_ID];
    if (Array.isArray(requestId)) {
      return requestId.join(' ');
    }
    return requestId || undefined;
  }
  return undefined;
};

export { getRequestIdFromHeaders };
